import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container } from './Home.styled';

interface Step1FormData {
  name: string;
  email: string;
  company: string;
  phone: string;
  title: string;
  message: string;
}

const defaultStep1: Step1FormData = {
  name: '',
  email: '',
  company: '',
  phone: '',
  title: '',
  message: '',
};

export const Contact: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [data, setData] = useState<Step1FormData>(defaultStep1);

  const source = useMemo(() => searchParams.get('source') || localStorage.getItem('cta_source') || 'unknown', [searchParams]);

  useEffect(() => {
    if (searchParams.get('source')) {
      localStorage.setItem('cta_source', searchParams.get('source') as string);
    }
  }, [searchParams]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const canProceedStep1 = useMemo(() => {
    return (
      data.name.trim() &&
      data.email.trim() &&
      data.company.trim() &&
      data.phone.trim() &&
      data.title.trim() &&
      data.message.trim()
    );
  }, [data]);

  const goNext = () => {
    if (!canProceedStep1) return;
    setStep(2);
  };

  const submit = async () => {
    setIsSubmitting(true);
    try {
      // Placeholder: Replace with real API call
      const payload = { step1: data, source };
      console.log('[CONTACT SUBMIT]', payload);
      localStorage.setItem('last_contact_payload', JSON.stringify(payload));
      await new Promise(r => setTimeout(r, 1200));
      navigate('/?submitted=1');
    } catch (e) {
      console.error(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main>
      <section style={{ padding: '120px 0' }}>
        <Container>
          <div style={{ maxWidth: 760, margin: '0 auto' }}>
            <div style={{ marginBottom: 24 }}>
              <h1 style={{ fontFamily: 'HGAlmond 80g, sans-serif', fontWeight: 'normal', fontSize: 48 }}>도입 문의</h1>
              <p style={{ opacity: 0.85 }}>요청 경로: {source}</p>
            </div>

            {step === 1 && (
              <div style={{ display: 'grid', gap: 16 }}>
                <div>
                  <label htmlFor="name">이름</label>
                  <input id="name" name="name" value={data.name} onChange={handleChange} placeholder="홍길동" required />
                </div>
                <div>
                  <label htmlFor="email">메일 주소</label>
                  <input id="email" type="email" name="email" value={data.email} onChange={handleChange} placeholder="you@example.com" required />
                </div>
                <div>
                  <label htmlFor="company">회사명</label>
                  <input id="company" name="company" value={data.company} onChange={handleChange} placeholder="(주)쓸모" required />
                </div>
                <div>
                  <label htmlFor="phone">연락처</label>
                  <input id="phone" name="phone" value={data.phone} onChange={handleChange} placeholder="010-0000-0000" required />
                </div>
                <div>
                  <label htmlFor="title">직책</label>
                  <input id="title" name="title" value={data.title} onChange={handleChange} placeholder="매니저" required />
                </div>
                <div>
                  <label htmlFor="message">문의 내용</label>
                  <textarea id="message" name="message" value={data.message} onChange={handleChange} rows={6} placeholder="도입 배경/요청 사항 등을 적어주세요." required />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 8 }}>
                  <button onClick={goNext} disabled={!canProceedStep1} style={{ padding: '14px 22px', borderRadius: 8, background: 'rgb(245,124,10)', border: '3px solid rgb(235,98,0)', color: '#000', cursor: canProceedStep1 ? 'pointer' : 'not-allowed' }}>다음</button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div style={{ display: 'grid', gap: 16 }}>
                <h2 style={{ fontFamily: 'HGAlmond 80g, sans-serif', fontWeight: 'normal' }}>미팅 일정 선택(예정)</h2>
                <p>CRM 연동 후 미팅이 가능한 시간대만 표시되고 선택할 수 있도록 구성할 예정입니다.</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                  <button onClick={() => setStep(1)} style={{ padding: '14px 22px', borderRadius: 8, background: 'transparent', border: '2px solid #fff', color: '#fff' }}>이전</button>
                  <button onClick={submit} disabled={isSubmitting} style={{ padding: '14px 22px', borderRadius: 8, background: 'rgb(245,124,10)', border: '3px solid rgb(235,98,0)', color: '#000', cursor: 'pointer' }}>{isSubmitting ? '전송 중...' : '제출하기'}</button>
                </div>
              </div>
            )}
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Contact;
